module.exports = __webpack_public_path__ + "static/media/rubber2_seamless.9297d41d.png";